module.exports = __webpack_public_path__ + "static/media/ACHIOTE_B_6.f08f4da3.png";